import React, { memo } from 'react';

import TopNavItemSpecialItemsHandler from '@/components/atomic/molecules/navigation/top-nav-items/item/special-items';
import type { TopNavigationItemProps } from '@/components/atomic/molecules/navigation/top-nav-items/item/typings';
import withExposer from '@/hocs/with-exposer';
import usePreloadedModel from '@/hooks/use-preloaded-model';
import normalisePath from '@/utils/path-helper';

const PreloadTopNavItemComponent: React.FC<TopNavigationItemProps> = (
	props,
) => {
	const {
		id,
		ariaLabel,
		fragmentVariationPath,
		icon,
		label,
		link,
		dropdownSegment,
		$variant,
	} = props;

	const model = usePreloadedModel(fragmentVariationPath, undefined, true);

	return (
		<TopNavItemSpecialItemsHandler
			id={id}
			ariaLabel={ariaLabel}
			label={label}
			link={normalisePath(link)}
			fragmentVariationPath={fragmentVariationPath}
			dropdownSegment={dropdownSegment}
			icon={icon}
			model={model}
			$variant={$variant}
		/>
	);
};

const PreloadTopNavItem = memo(
	withExposer(PreloadTopNavItemComponent, 'preloadTopNavItem'),
);

export default PreloadTopNavItem;
